module.exports = __webpack_public_path__ + "static/media/question_rating.56627bd4.png";